// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3h41H","list":"BalanceDue_list__3gJHG","listRow":"BalanceDue_listRow__2b4cH","total":"BalanceDue_total__28wnq"};